const illegalExp = /[\u0000-\u0009]|[\u000b-\u001f]|[\u007f-\u009f]|[\uffff]/g
export {
  illegalExp
}
